import { useCallback } from "react";
import { useInjection } from "@linkfluence/core/di";
import { useMutation } from "@tanstack/react-query";
import { ProjectRepo, ProjectRepositoryUID } from "../repositories/ProjectRepo";

export function useContactProjectManager(project: number) {
  const repository = useInjection<ProjectRepo>(ProjectRepositoryUID);
  const { mutateAsync, isLoading, data } = useMutation(
    async (data: { subject: string; content: string }) => {
      return await repository.contactProjectManager(
        project,
        data.subject,
        data.content
      );
    }
  );
  const contactProjectManager = useCallback(
    (subject: string, content: string) => {
      return mutateAsync({ subject, content });
    },
    [mutateAsync]
  );
  return {
    contactProjectManager,
    loading: isLoading,
    data,
  };
}
